import classNames from 'classnames'
import './PaymentSelector.scss'
import { IPaymentSelectorProps } from './types'
import { __ } from '@wordpress/i18n'
import { useWording } from '../../hooks/useWording'

export const PaymentSelector = ({
    methods,
    selectedMethod,
    setSelectedMethod,
}: IPaymentSelectorProps) => {
    const wording = useWording()
    return (
        <div className={'wbk_payment-selector__wrapper'}>
            {(methods &&
                methods.length > 0 &&
                methods.map(({ name, id, icon }, index) => (
                    <div
                        className={classNames(
                            'wbk_payment-selector__method',
                            'wbk_payment-selector__method--appear',
                            {
                                'wbk_payment-selector__method--selected':
                                    selectedMethod === id,
                            }
                        )}
                        style={{ animationDelay: `${index * 80}ms` }}
                        onClick={() => setSelectedMethod(id)}
                    >
                        {icon && <img src={icon} alt={name} />}
                        <span>{name}</span>
                    </div>
                ))) || (
                <div className={'wbk_payment-selector__no-methods'}>
                    {__(
                        'No payment methods found, contact administrator!',
                        'webba-booking-lite'
                    )}
                </div>
            )}
        </div>
    )
}
